import SubItems from '@/components/InspectionReport/Items/SubItems';

export default {
    name: 'ConditionalSection',
    functional: true,
    render(createElement, { props }) {
        if (props.item.allConditionsMet === false) return null;
        return createElement(SubItems, {
            props: {
                items: props.item.items,
                resource: props.resource,
            },
        });
    },
};
